export const NOTIFICATION_LIST_COLUMN = "NOTIFICATION_LIST_COLUMN";